import React, { useState, useRef } from 'react';
import styles from './Reactions.module.scss';
import cx from 'classnames';
import Emoji from '../../Emoji/Emoji';
import ReactionsList from './ReactionsList';
import useOutsideClick from '../../../hooks/useOutsideClick';

const Reactions = ({
  user,
  reactions,
  handleReaction,
  reactionStatisticsBar,
  reactionStatistics,
  isMobileView,
  username,
  localStorageCommentReactions,
}) => {
  const [showReactiosList, setShowReactionList] = useState(false);

  const toggleReactionList = () => {
    setShowReactionList(!showReactiosList);
  };

  const reactionListRef = useRef();
  useOutsideClick(reactionListRef, () => setShowReactionList(false));

  return (
    <div className={styles.reactionsContainer}>
      <div className={styles.reactions}>
        {reactionStatisticsBar?.map(reaction => (
          <li
            key={reaction.unicode}
            className={cx(
              styles.reaction,
              { [styles.selectedReaction]: reaction.selected },
              { [styles.defaultCursor]: !user && reaction.selected }
            )}
            onClick={() => handleReaction(reaction)}
          >
            <Emoji unicode={reaction.unicode} />
            <span className={styles.reactionNumber}>{reaction.amount}</span>
          </li>
        ))}
      </div>
      {reactions && reactions?.length > 0 ? (
        <div className={styles.listContainer} ref={reactionListRef}>
          <span className={styles.openReactions} onClick={toggleReactionList}>
            {reactions.length}
          </span>
          {isMobileView ? null : <span className={styles.elapsedTime}>-</span>}
          {showReactiosList ? (
            <ReactionsList
              user={user}
              reactionStatistics={reactionStatistics}
              reactions={reactions}
              username={username}
              localStorageCommentReactions={localStorageCommentReactions}
              setShowReactionList={setShowReactionList}
              handleReaction={handleReaction}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default Reactions;
